import React from 'react';
import './FormErrorMessage.css';

function FormErrorMessage({ message, className = '' }) {
    if (!message) return null;

    return (
        <div
            className={`form-error-message ${className}`.trim()}
            role="alert"
            aria-live="polite"
        >
            {message}
        </div>
    );
}

export default FormErrorMessage;
